/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const SafetyTool = ({ color = 'primary', aspectRatio = '1114/171', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="SafetyTool" aspectRatio={aspectRatio} color={color} {...rest} />;

export { SafetyTool, SafetyTool as default };
